import apiHandler from '../../utilities/apiHandler.js';

const HeaderApiHandler = {

	getAllFacilities: function () {
		//var URL = "space/facility?status=true";
		var URL = "space/facility/owner?ownerId=ORGPROF-1304473903";
        return apiHandler.get(URL);
    }

}

export default HeaderApiHandler;


// WEBPACK FOOTER //
// ./src/screens/Header/HeaderApiHandler.js